import { ref } from 'vue';
export function useBase64UrlDecoder() {
	// Helper function to extract Base64 from MIME encoded strings
	const extractBase64FromMime = (mimeString: string): string => {
		// Check if the string is in the MIME encoded-word format
		if (mimeString.startsWith('=?') && mimeString.endsWith('?=')) {
			// Split the MIME string into parts
			const parts = mimeString.split('?');
			if (parts.length === 5 && parts[2].toUpperCase() === 'B') {
				// Extract the Base64 portion
				return parts[3];
			}
		}
		// If not a MIME encoded string, return the original string
		return mimeString;
	};
	const base64UrlEncode = (buffer: ArrayBuffer): string => {
		// Convert binary to Base64
		let binary = '';
		const bytes = new Uint8Array(buffer);
		for (let i = 0; i < bytes.length; i += 1) {
			binary += String.fromCharCode(bytes[i]);
		}

		// Convert Base64 to Base64URL
		return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
	} 
	const  decodeBinaryString =(binaryStr:string):string => {
		// Check if the string is in the binary format
		if (binaryStr.startsWith('=?BINARY?B?') && binaryStr.endsWith('?=')) {
			// Extract the Base64-encoded part
			return binaryStr.slice(11, -2);
		}
		// If it's not a binary string, assume it's already Base64URL-encoded
		return binaryStr;
	};
	const arrayBufferToBase64 = (buffer: ArrayBuffer): string => {
		let binary = '';
		const bytes = new Uint8Array(buffer);
		for (let i = 0; i < bytes.byteLength; i += 1) {
			binary += String.fromCharCode(bytes[i]);
		}
		return btoa(binary);
	};

	const arrayBufferToBase64URL=(buffer: ArrayBuffer): string => {
		return btoa(String.fromCharCode(...new Uint8Array(buffer)))
		.replace(/\+/g, "-")
		.replace(/\//g, "_")
		.replace(/=+$/, "");
	}

	/**
	 * Converts a Base64URL-encoded string to an ArrayBuffer.
	 * @param base64URL - The Base64URL string to convert.
	 * @returns An ArrayBuffer.
	 */
	const base64URLToArrayBuffer=(base64URL: string): ArrayBuffer => {
		const base64 = base64URL.replace(/-/g, "+").replace(/_/g, "/");
		const binaryString = atob(base64);
		const length = binaryString.length;
		const buffer = new Uint8Array(length);
		for (let i = 0; i < length; i++) {
			buffer[i] = binaryString.charCodeAt(i);
		}
		return buffer.buffer;
	}
	const  base64ToArrayBuffer=(base64:string): ArrayBuffer => {
		// Decode the binary string if necessary
		const decoded = decodeBinaryString(base64);

		// Convert Base64URL to Base64
		const base64Converted = decoded.replace(/-/g, '+').replace(/_/g, '/');

		// Decode Base64 to binary
		const binaryString = atob(base64Converted);

		// Convert binary string to ArrayBuffer
		const len = binaryString.length;
		const bytes = new Uint8Array(len);
		for (let i = 0; i < len; i += 1) {
			bytes[i] = binaryString.charCodeAt(i);
		}
		return bytes.buffer;
	};



	// Base64URL decode function
	const base64UrlDecode = (str: string): Uint8Array => {
		// Extract Base64 from MIME encoded string if necessary
		const base64 = extractBase64FromMime(str);

		// Convert Base64URL to standard Base64
		let standardBase64 = base64.replace(/-/g, '+').replace(/_/g, '/');
		while (standardBase64.length % 4) {
			standardBase64 += '=';
		}

		// Decode the Base64 string to a binary string
		const binaryString = atob(standardBase64);

		// Convert the binary string to a Uint8Array
		return Uint8Array.from(binaryString, (c) => c.charCodeAt(0));
	};

	return {
		base64UrlDecode,
			base64UrlEncode,
			base64ToArrayBuffer,
			arrayBufferToBase64URL,
			base64URLToArrayBuffer,
			arrayBufferToBase64
	};
}

